import React from 'react';
import $ from 'jquery';
import InfraTable from '../infraresults/infratable';
import PtQuali from '../infraresults/ptresult';
import { Link } from 'react-router-dom'
import CompareChart from './comparison_chart'
import CompareTable from './coststable'
import PrintButton from '../print_button';

/**ONLY FOR DEV**/
//import Dev from '../../../models/dev';
/**DEV END**/

export default class ResultsPage extends React.Component {
	constructor(props) {
		super(props);
		/**ONLY FOR DEV**/
//		var dev = new Dev();
//		dev.setUpDataForResults();
		/**DEV END**/
		this.lp1 = window.datastore.lps.get("1")
		this.lp2 = window.datastore.lps.get("2")
	}
	render() {
	    return (
<div className="pagecontainer">
    <nav className="navbar navbar-default">
        <div className="container-fluid header">
            <div>
                <ol className="breadcrumb">
                    {<li className=""><Link to={"/wohnstandorte/1/addressmap"}>Zu Wohnstandort 1</Link></li>}
                    <li className=""><Link to={"/wohnstandorte/2/addressmap"}>{this.props.match.params.placeid === "2" ? "Vergleichsstandort" : "Wohnstandort"}</Link></li>
                    <li className=""><Link to={"/wohnstandorte/2/infrastruktur"}>Infrastruktur</Link></li>
                    <li className=""><Link to={"/wohnstandorte/2/wohnkosten"}>Wohnkosten</Link></li>
                    <li className=""><Link to={"/wohnstandorte/2/taeglichewege"}>Mobilität</Link></li>
                    <li className="active">Vergleich</li>
                </ol>
            </div>
        </div>
    </nav>
    <div className="container-fluid normal-page">
        <h3>Vergleich der beiden Wohnstandorte</h3>
        <span className="help-block">Hier sehen sie die Infrastruktur und Kosten der beiden Standorte im Vergleich</span>
        <hr></hr>
	<div className="row">
            <div className="col-md-4">
                    <CompareChart />
            </div>
            <div className="col-md-8">
                <CompareTable placeid="2" />
            </div>
        </div>
        <div className="panel panel-default">
            <div className="panel-body">
                <div className="row">
                    <div className="col-md-6">
                        <h4>Infrastruktur: {this.lp1.get('name')}</h4>
                        <InfraTable routes={this.lp1.get('targetroutes')} traveltimescenter={this.lp1.get('traveltimescenter')}>
                        </InfraTable>
                        <PtQuali ptquali={this.lp1.get('ptquali')}/>
                    </div>
                    <div className="col-md-6">
                        <h4>Infrastruktur: {this.lp2.get('name')}</h4>
                        <InfraTable routes={this.lp2.get('targetroutes')} traveltimescenter={this.lp2.get('traveltimescenter')}>
                        </InfraTable>
                        <PtQuali ptquali={this.lp2.get('ptquali')}/>
                    </div>
                </div>
            </div>
        </div>
        <hr />
        <div className="btn-infra-controls">
		<PrintButton enabled={true}/>
		</div>
		<div className="help-block smalltext">
		<p />
	    Sämtliche Daten und Informationen wurden sorgfältig ermittelt. 
	    Es kann jedoch keine Garantie für die Richtigkeit, 
	    Vollständigkeit und Aktualität der Angaben übernommen werden. Datenquellen: Land Oberösterreich, GIP, VAO, basemap.at, OSM, iSPACE
	    </div>
    </div>
</div>
	    )
	}
}



// WEBPACK FOOTER //
// ./src/react_components/livingplaceprocess/results/comparison_page.js